module.exports = __webpack_public_path__ + "img/2026.c9e6a0d5.svg";